﻿import React, { useState, useEffect } from 'react';
import { Dialog } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import { HelperFunctions } from 'helpers';
import classNames from 'classnames';
import { ModalSize } from 'components/notifications/ModalSize';
import './Notifications.css';

export function Modal(
    {
        title = "",
        isOpen = false,
        onClose = null,
        onOpened = null,
        showCloseButton = true,
        clickOutsideClose = true,
        wide = false,
        extraWide = false,
        updateStateOnClose = true,
        fullScreen = false,
        className = "",
        size = ModalSize.MEDIUM,
        autoFocus = false,
        enforceFocus = false,
        fixedHeightPercentage = 90,
        footer = null,
        overflowAuto = false,
        children,
        fixedHeight
    }
) {
    const [isOpenValue, setIsOpen] = useState(false);

    useEffect(() => {
        setIsOpen(isOpen);
    }, [isOpen]);

    function handleClose() {
        HelperFunctions.executeIfNotNull(onClose);
        if (updateStateOnClose) {
            setIsOpen(false);
        }
    }

    function handleOpened() {
        HelperFunctions.executeIfNotNull(onOpened);
    }

    return (
        <Dialog
            isOpen={isOpenValue}
            title={title}
            isCloseButtonShown={showCloseButton}
            onClose={handleClose}
            onOpened={handleOpened}
            autoFocus={autoFocus}
            enforceFocus={enforceFocus}
            canOutsideClickClose={clickOutsideClose}
            className={classNames("modal-holder", size, className, { "modal-holder-fixed": fixedHeight })}
            style={fixedHeight ? { height: `${fixedHeightPercentage}vh` } : {}}
        >
            <div className={classNames("bp6-dialog-body modal-body", { "modal-body-overflow-auto": overflowAuto })}>
                {children}
            </div>
            {footer && <div className="bp6-dialog-footer">{footer}</div>}
        </Dialog>
    );
}

Modal.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]),
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    showCloseButton: PropTypes.bool,
    clickOutsideClose: PropTypes.bool,
    updateStateOnClose: PropTypes.bool,
    className: PropTypes.string,
    size: PropTypes.oneOf(["small", "medium", "large", "superwide", "supersmall"]),
    autoFocus: PropTypes.bool,
    enforceFocus: PropTypes.bool,
    fixedHeight: PropTypes.bool,
    fixedHeightPercentage: PropTypes.number,
    footer: PropTypes.element,
    onOpened: PropTypes.func,
    children: PropTypes.node.isRequired,
    overflowAuto: PropTypes.bool
};